import styled from 'styled-components';
import { Container, Col } from 'react-bootstrap';
import SectionTitle from 'components/SectionTitle';
import { mediaBreakpointDown, mediaBreakpointUp } from 'utils/styledCssHelpers';
import DotSVG from 'components/DotSVG';
import HalfCircleShape from 'components/Shapes/HalfCircle';

const getBackgroundColor = props => {
  return props.theme.colors.alice_blue_2;
};

export const SSection = styled.section`
  position: relative;
  padding-top: 85px;
  padding-bottom: 50px;

  ${mediaBreakpointUp(
    'lg',
    `
    padding-top: 100px;
    padding-bottom: 100px;

  `,
  )}
`;
export const SContainer = styled(Container)``;

export const STextContent = styled(Col)``;

export const SImageContent = styled(Col)``;

export const STitle = styled.div`
  font-size: inherit;
  text-align: center;

  & span {
    font-size: inherit;
    &.highlight {
      color: ${props => props.theme.colors.pastel_blue};
    }
  }
`;

export const SParagraph = styled.p`
  text-align: center;
  ${mediaBreakpointUp(
    'xl',
    `
padding: 0 115px !important;

`,
  )}
  ${mediaBreakpointUp(
    'lg',
    `
  padding: 0 50px;

`,
  )}
`;

export const SSectionTitle = styled(SectionTitle)`
  margin-top: 20px;
  ${mediaBreakpointUp(
    'xl',
    `
padding: 0 120px !important;
`,
  )}
  ${mediaBreakpointUp(
    'lg',
    `
padding: 0 65px;
`,
  )}
`;

export const SDotSvg = styled(DotSVG)`
  top: 105px;
  width: 100%;
  left: 0;
  overflow: hidden;
  ${mediaBreakpointUp(
    'md',
    `
    width: 70%;
`,
  )}
`;

export const SPlaceholder = styled.div`
  position: relative;

  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover svg {
    color: ${props => props.theme.colors.main};
  }
`;

export const SPlayButtonIcon = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: ${props => props.theme.colors.pastel_blue};
  }
`;

export const SContentSection = styled.section`
  width: 100%;

  ${mediaBreakpointUp(
    'sm',
    `
  width: 70%;
`,
  )}
`;

export const SHalfCircleShape = styled(HalfCircleShape)`
  ${mediaBreakpointDown(
    'md',
    `
  transform: rotate('0'}) translateY(-283px) scale(1);
  
  `,
  )}
`;
